import React, { useRef, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LivePreview = ({ room, colors, intensity, heaviness, finish }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef?.current && room && colors?.length > 0) {
      renderPreview();
    }
  }, [room, colors, intensity, heaviness, finish]);

  const renderPreview = () => {
    const canvas = canvasRef?.current;
    const ctx = canvas?.getContext('2d');
    const img = new window.Image();
    
    img.crossOrigin = 'anonymous';
    img.src = room?.backgroundImage;
    
    img.onload = () => {
      canvas.width = img?.width;
      canvas.height = img?.height;
      
      ctx?.drawImage(img, 0, 0);
      
      const overlayIntensity = intensity / 100;
      colors?.forEach((color, index) => {
        const alpha = (overlayIntensity / colors?.length) * (heaviness / 100);
        ctx.fillStyle = `${color?.hex}${Math.floor(alpha * 255)?.toString(16)?.padStart(2, '0')}`;
        ctx?.fillRect(0, 0, canvas?.width, canvas?.height);
      });
    };
  };

  const handleDownload = () => {
    const canvas = canvasRef?.current;
    const link = document.createElement('a');
    link.download = `epoxy-preview-${Date.now()}.png`;
    link.href = canvas?.toDataURL();
    link?.click();
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-text-primary">Live Preview</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={handleDownload}
          iconName="Download"
          iconPosition="left"
          iconSize={16}
        >
          Download
        </Button>
      </div>
      <div className="relative bg-muted rounded-lg overflow-hidden border border-border">
        <canvas
          ref={canvasRef}
          className="w-full h-auto"
        />
        
        {(!room || colors?.length === 0) && (
          <div className="absolute inset-0 flex items-center justify-center bg-muted">
            <div className="text-center">
              <Icon name="Image" size={48} className="mx-auto mb-3 text-text-secondary" />
              <p className="text-sm text-text-secondary">
                Select room and colors to see preview
              </p>
            </div>
          </div>
        )}
      </div>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="bg-card border border-border rounded-lg p-3">
          <span className="text-text-secondary">Finish:</span>
          <span className="ml-2 font-medium text-text-primary capitalize">{finish}</span>
        </div>
        <div className="bg-card border border-border rounded-lg p-3">
          <span className="text-text-secondary">Colors:</span>
          <span className="ml-2 font-medium text-text-primary">{colors?.length}</span>
        </div>
        <div className="bg-card border border-border rounded-lg p-3">
          <span className="text-text-secondary">Intensity:</span>
          <span className="ml-2 font-medium text-text-primary">{intensity}%</span>
        </div>
        <div className="bg-card border border-border rounded-lg p-3">
          <span className="text-text-secondary">Heaviness:</span>
          <span className="ml-2 font-medium text-text-primary">{heaviness}%</span>
        </div>
      </div>
    </div>
  );
};

export default LivePreview;